import React from "react";
import {
  FaShieldAlt,
  FaUsers,
  FaLeaf,
  FaFileContract,
  FaSyncAlt,
  FaChartLine,
} from "react-icons/fa";

function Governance() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-8">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Key Benefits of Tezos Blockchain Development with Xeer
                  Technology
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pt-30">
                    <FaShieldAlt size={40} />
                  </div>
                  <h4>Institutional-Grade Security</h4>
                  <p>
                    Tezos is built to ensure asset security and reliability at
                    both the protocol and application levels using OCaml and
                    Michelson languages. These advanced languages facilitate
                    formal verification for enhanced protection, ideal for
                    high-value use cases.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pt-30">
                    <FaUsers size={40} />
                  </div>
                  <h4>Governance by the Community</h4>
                  <p>
                    Tezos stands out for its governance model, empowering users
                    to drive network upgrades and improvements, making it truly
                    decentralized and community-led. This model aligns Web3 with
                    user-focused principles.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pt-30">
                    <FaLeaf size={40} />
                  </div>
                  <h4>Energy-Efficient Consensus Mechanism</h4>
                  <p>
                    Tezos employs an energy-efficient proof-of-stake algorithm,
                    minimizing its carbon footprint while offering a robust
                    solution for blockchain applications.
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pt-30">
                    <FaFileContract size={40} />
                  </div>
                  <h4>Advanced Smart Contracts</h4>
                  <p>
                    Tezos smart contracts prioritize security and reliability,
                    utilizing languages that allow formal verification for
                    critical functions, ideal for high-stakes applications.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pt-30">
                    <FaSyncAlt size={40} />
                  </div>
                  <h4>Seamlessly Upgradeable</h4>
                  <p>
                    Tezos’s unique on-chain governance and upgradeability ensure
                    that the platform remains adaptable, evolving with emerging
                    tech trends without disruptive forks.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="process-style-two-item">
                  <div className="icon pb-20 pt-30">
                    <FaChartLine size={40} />
                  </div>
                  <h4>High Scalability</h4>
                  <p>
                    Tezos’s architecture enables it to handle complex
                    transactions and high-volume applications, offering scalable
                    solutions for any industry requirement.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Governance;
